import { render, staticRenderFns } from "./SafeAuth.vue?vue&type=template&id=bdc33238&scoped=true"
import script from "./SafeAuth.vue?vue&type=script&lang=js"
export * from "./SafeAuth.vue?vue&type=script&lang=js"
import style0 from "./SafeAuth.vue?vue&type=style&index=0&id=bdc33238&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc33238",
  null
  
)

export default component.exports